module.exports = __webpack_public_path__ + "img/g5.38edcd4a.png";